export { default as AvatarMenuV2 } from './avatar-menu-v2';
